import React, { useEffect, useRef, useState } from "react";
import styles from "./ClientsView.module.css";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Langs from "../../app/lang/langs";
import { getCollabsNames } from "../../components/vcomp/vcompSlice";
import ClientsTab from "./ClientsTab";
import { getClients } from "../../components/clients/clientsSlice";
import { getTeams } from "../../components/teams/teamsSlice";
import { getAllCollabs, getPostes } from "../../components/collabs/collabsSlice";
import { ViewSelectButton } from "../../components/buttons/ViewSelectButton";
import addIcon from '../../assets/images/add.png'
import addIconFocus from '../../assets/images/addFocus.png'
import ImageButton from "../../components/buttons/ImageButton";
import SubcontractorsTab from "./SubcontractorsTab";
import { getSubcontractors } from "../../components/clients/clientsSlice";
import TeamsTab from "./TeamsTab";
import { useNavigate, useParams } from "react-router-dom";

export default function ClientsView() {

    const mounted = useRef(null)

    const dispatch = useDispatch()
    const urlParams = useParams()
    const navigate = useNavigate()
    const isMobile = useSelector((state) => state.settings.isMobile)
    const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)

    const [viewsOptions, setViewOptions] = useState([
        { label: <Langs str='CLIENTS' />, value: 0 },
        { label: <Langs str='TEAMS' />, value: 1 },
        { label: <Langs str='SUBCONTRACTORS' />, value: 2 }
    ]);
    const [selectedView, setSelectedView] = useState(0)
    const [addOpportunitieModalVisible, setAddOpportunitieModalVisible] = useState(false)

    useEffect(() => {
        if (!mounted.current) {
            dispatch(getCollabsNames())
            dispatch(getClients())
            dispatch(getTeams())
            dispatch(getAllCollabs())
            dispatch(getPostes())
            dispatch(getSubcontractors())
            dispatch(getAllCollabs())
        }
        mounted.current = true
    }, [mounted])

    useEffect(() => {
        if (urlParams.subView && viewsOptions[urlParams.subView]) {
            setSelectedView(urlParams.subView)
        }
    }, [urlParams])

    const handleViewChange = (view) => {
        if (view != null) {
            let selectedTeamId = selectedTeamsIds[0]
            navigate(`/clients/${selectedTeamId}/${view}`)
        }
    }
    
    const header = (view) => {
        return (
            <div className="topMenu" style={{ height: 'auto' }}>
                <Row>
                    <Col lg={4} xs={12} className="d-flex align-items-center">
                        <span className="headerTitle">
                            {viewsOptions[selectedView].label}
                        </span>
                        {isMobile === 2 && view === 1 && (
                            <ImageButton
                                image={addIcon}
                                imageFocus={addIconFocus}
                                onClick={() => {
                                    setAddOpportunitieModalVisible(true);
                                }}
                                active={true}
                                width={30}
                                className="ms-3"
                            />
                        )}
                    </Col>
                    <Col
                        lg={4}
                        xs={12}
                        className={
                            isMobile === 1 || isMobile === 3
                                ? "d-flex justify-content-center"
                                : "d-flex justify-content-start mt-2"
                        }
                    >
                        <ViewSelectButton
                            options={viewsOptions}
                            selectedView={viewsOptions.find(o => o.value == selectedView)?.value}
                            onViewChange={handleViewChange}
                        />
                    </Col>
                    {isMobile !== 2 && (
                        <Col
                            lg={4}
                            xs={3}
                            className={
                                isMobile === 1 || isMobile === 3
                                    ? "d-flex justify-content-end"
                                    : "d-flex justify-content-end mt-2"
                            }
                        >
                            {view === 1 && (
                                <div></div>
                                // <ImageButton
                                //     image={addIcon}
                                //     imageFocus={addIconFocus}
                                //     onClick={() => {
                                //         setAddOpportunitieModalVisible(true);
                                //     }}
                                //     active={true}
                                //     width={32}
                                // />
                            )}
                        </Col>
                    )}
                </Row>
            </div>
        );
    };

    const body = (view) => {
        if (view == 0) {
            return (
                <ClientsTab />
            )
        }
        if (view == 1) {
            return (
                <TeamsTab />
            )
        }
        if (view == 2) {
            return (
                <SubcontractorsTab />
            )
        }
        return (
            <p>Nice try Sherlock!</p>
        )
    }
    return (
        <div>
            {header(selectedView)}
            {body(selectedView)}
        </div>
    )
}